import React from 'react'
import loaderImg from '../../../assets/images/ajax-loader.gif'

const styles={
    height:'200px',
    margin: '0 auto',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#fff',
    alignItems: 'center',
    borderRadius: '15px'
}

const Loader = () => {
    return (    
        <div style={styles}>
            <img src={loaderImg} width="32" height="32" alt="Loading..." />
        </div>
    )
}
export default Loader